import React, { useEffect, useState } from 'react';

import { useNavigate  } from 'react-router-dom';


import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import Cookies from 'js-cookie';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box, Button, TextField, Checkbox, FormGroup, FormControlLabel, FormControl, Typography, Divider } from '@mui/material';

import { Sources, ordersToExcelTable } from '../helpers/scripts'

import cl from '../static/style.module.css'

import axios from '../config';

import { useFilter } from '../hoc/FilterProvider'

import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';

const OrdersSearchBar = ({ orders, updateOrders, statData, setProgressBarVisible, updateUrlPage, urlPage }) => {

    const { stateSearchData, updateStateSearchData, updateDefaultStateSearchData  } = useFilter();
    const [copied, setCopied] = useState(false)

    let navigate = useNavigate()


    const dataSearch = () => {
        const newDataSearch = {
            'date_from': dayjs(stateSearchData.date_from).format(),
            'date_to': dayjs(stateSearchData.date_to).format()
        }
        if (stateSearchData.email) {
            newDataSearch['email'] = stateSearchData.email
        }
        if (stateSearchData.name) {
            newDataSearch['name'] = stateSearchData.name
        }
        if (stateSearchData.orderNumber) {
            newDataSearch['orderID'] = stateSearchData.orderNumber
        }
        if (stateSearchData.country) {
            newDataSearch['country'] = stateSearchData.country
        }
        if (stateSearchData.sources.length > 0) {
            newDataSearch['sources'] = stateSearchData.sources.join()
        }
        
        return newDataSearch

    }



    const updateFilds = () => {
        getOrders()
        updateUrlPage(0)
            }

    const getOrders = async () => {

        setProgressBarVisible(true)
        const rs = await axios.get('/uorders',
            { params: { ...dataSearch() },
             headers: {'token': Cookies.get('token')} }
        )

        try {
            if (rs.data) {
                updateOrders(rs.data.data)
                // console.log(rs.data.data)
            }
        }
        catch (error) {
            console.log(error)

        }
        setProgressBarVisible(false)
    }

    const copyTable = async () => {
        const rows = (orders || []).map((order) => ({
            ...order,
            date: dayjs(order.date).format('DD/MM/YYYY HH:mm:ss'),
        }))
        await navigator.clipboard.writeText(ordersToExcelTable(rows))
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
    }

    const addOrder = async () => {
        const rs = await axios.put('/uorders/new', {}, {headers:{'token': Cookies.get('token')}})
        console.log(rs.data)
        try {
            if (rs.data.id) {
                navigate(`/orders/${rs.data.id}`)
            }
        }
        catch (error){
            console.log(error)
        }
    }


    // useMemo(() => {
       useEffect(() => {
        updateFilds()
    }, [updateStateSearchData])



    const formaterSources = () => {
        let lst = []
        Object.values(Sources).map(i => {
            lst.push({
                code: i.code,
                name: i.name
            })
            // setSurces([...sources, i.code])
        })
        return lst
    }



    return (
        <div id={cl.ordersSearchBar} style={{marginBottom: '20px'}}>

            <Box
                component="form"
                sx={{
                    '& > :not(style)': { m: 0.3, width: '24ch' },
                    display:'flex',
                    justifyContent: 'space-between'
                }}
                noValidate
                autoComplete="off"
            >

                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'>
                    <DatePicker
                        name='date_from'
                        label="Заказы с"
                        className={cl.text_area_box}
                        value={stateSearchData.date_from}
                        maxDate={stateSearchData.date_to}
                        onChange={(e) => updateStateSearchData(e, 'date_from')}
                    />

                    <DatePicker
                        name='date_to'
                        sx={{ ml: 2, }}
                        className={cl.text_area_box}
                        label="Заказы по"
                        value={stateSearchData.date_to}
                        onChange={(e) => updateStateSearchData(e, 'date_to')}
                    />

                </LocalizationProvider>

                <TextField
                    name='email'
                    onChange={(e) => updateStateSearchData(e, 'input')}
                    value={stateSearchData.email}
                    label="Email"
                    sx={{ ml: 2, }}
                    className={cl.text_area_box}
                />

                <TextField
                    name='name'
                    onChange={(e) => updateStateSearchData(e, 'input')}
                    value={stateSearchData.name}
                    label="Имя Фамилия"
                    sx={{ ml: 2, }}
                    className={cl.text_area_box}
                />

                <TextField
                    name='orderNumber'
                    onChange={(e) => updateStateSearchData(e, 'input')}
                    value={stateSearchData.orderNumber}
                    label="Номер заказа"
                    sx={{ ml: 2, }}
                    className={cl.text_area_box}
                />

                <TextField
                    name='country'
                    value={stateSearchData.country}
                    onChange={(e) => updateStateSearchData(e, 'input')}
                    label="Страна"
                    sx={{ ml: 2, }}
                    className={cl.text_area_box}
                />


            </Box>

            <div style={{ marginTop:'13px', marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }} >



                    <FormGroup sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', m: 0, alignItems: 'center' }}>
                        {
                            formaterSources().map(i =>
                                <FormControlLabel
                                    key={i.code}
                                    sx={{
                                        ml: 0,
                                        mr: 1.25,
                                        '& .MuiFormControlLabel-label': { fontSize: 12, marginLeft: '2px' },
                                    }}
                                    control={
                                        <Checkbox
                                            id={i.code}
                                            checked={stateSearchData.sources.includes(i.code)}
                                            onChange={(e) => updateStateSearchData(e, 'checkbox')}
                                            size='small'
                                            sx={{ p: '4px' }} />}
                                    label={i.name}
                                />

                            )}

                    </FormGroup>


                    <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0, gap: 0.75, mt: 0.5 }}>
                        <Typography sx={{ whiteSpace: 'nowrap', fontSize: 12 }} color="initial">{statData ? `${statData.numberOfOrders} | ${statData.totalQuantities}` : 'no'}</Typography>
                        <AddBoxOutlinedIcon
                            onClick={()=>addOrder()}
                            sx={{ color:'#1976d2', cursor:'pointer', fontSize: 20 }}/>
                        <Button
                            size='small'
                            variant="outlined"
                            disabled={!orders || orders.length === 0}
                            onClick={copyTable}
                            sx={{ fontSize: 11, px: 1 }}
                        >{copied ? 'Скопировано' : 'Копировать'}</Button>
                        <Button
                            size='small'
                            variant="outlined"
                            onClick={() => updateDefaultStateSearchData()}
                            sx={{ fontSize: 11, px: 1 }}
                        >Очистить фильтры</Button>
                    </Box>
                    

            </div>
            <Divider />



        </div>
    );
}

export default OrdersSearchBar;
